import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { COLORS as TRUECOLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';

export const Annotation = styled.div`
    width: 100%;
`;

export const Content = styled.div`
    display: flex;
    flex-wrap: nowrap;
    width: 100%;

    @media (max-width: ${breakePoints.mobile}) {
        flex-direction: column;
        padding-bottom: 40px;
    }
`;

export const TextContent = styled.div`
    flex: 1 0 1%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    max-width: 875px;
    padding-right: 10px;

    @media (max-width: ${breakePoints.mobile}) {
        max-width: none;
        padding-top: 25px;
    }
    
    ${H4} {
        color: ${TRUECOLORS.TextSecondary};
    }
`;

export const ImgContent = styled.div`
    position: relative;
    flex: 1 1 1%;
    width: 100%;
`;

export const Image = styled.img`
    position: relative;
    width: 100%;
    height: auto;
    object-fit: contain;
`;

export const Title = styled.div`
    margin-bottom: 12px;
    ${FONTS.H4};
    color: ${COLORS.RED_FIRM};

    @media (max-width: ${breakePoints.tablet}) {
        ${FONTS.H5};
    }

    @media (max-width: ${breakePoints.mobile}) {
        width: 250px;
    }
`;

export const Text = styled.div`
    ${FONTS.H2};

    @media (max-width: ${breakePoints.sDesktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakePoints.tablet}) {
        ${FONTS.H4};
    }
`;
